import { useStableNavigate } from "../Components/StableNavigateContext";

const useShowCargoModal = () => {
  const navigate = useStableNavigate();
  return (id: string, routeId?: string) => {
    navigate({
      hash: `cargo=${id}${routeId ? `&route=${routeId}` : ""}`,
      search: window.location.search,
    });
  };
};

export default useShowCargoModal;
